var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 38,
    viewBox: "0 0 56 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.086 25.4229C24.086 22.6128 23.2162 20.2042 21.4767 18.197C19.7372 16.0561 17.5293 14.6511 14.853 13.982C15.1207 12.2425 15.7897 10.436 16.8602 8.56264C18.0645 6.55547 19.3357 4.94974 20.6738 3.74544L16.6595 0.333252C5.55317 7.69287 0 16.0561 0 25.4229C0 28.902 1.1374 31.8458 3.41219 34.2544C5.82079 36.5292 8.69773 37.6666 12.043 37.6666C15.3883 37.6666 18.1983 36.4623 20.4731 34.0537C22.8817 31.6451 24.086 28.7681 24.086 25.4229ZM56 25.4229C56 22.6128 55.1302 20.2042 53.3907 18.197C51.6511 16.0561 49.4432 14.6511 46.767 13.982C47.1685 12.1086 47.9044 10.2353 48.9749 8.36193C50.1792 6.48857 51.4504 4.94974 52.7885 3.74544L48.5735 0.333252C37.3333 7.96049 31.7133 16.3237 31.7133 25.4229C31.7133 28.7681 32.9176 31.6451 35.3262 34.0537C37.7348 36.4623 40.6117 37.6666 43.957 37.6666C47.1685 37.6666 49.9785 36.4623 52.3871 34.0537C54.7957 31.6451 56 28.7681 56 25.4229Z",
    fill: "#610BEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.48a79949771c72b1e3bbcdb35888283d.svg";
export { ForwardRef as ReactComponent };